var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('v-progress-circular',{attrs:{"rotate":-90,"size":20,"width":10,"value":_vm.countDown,"color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }